import { PickupPoint, PointType } from '../types';

export const getPointTypes = (points: PickupPoint[]): PointType[] => {
  return [...new Set(points.map((point) => point.type))];
};
